import ScriptEditor from "components/ScriptEditor";
import React from "react";

function ScriptNotes() {
  return (
    <div className=" pb-0">
      <ScriptEditor />
    </div>
  );
}

export default ScriptNotes;
